export function ChevronDown(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M19.4229 5.17424c-.3744-.37409-.882-.58413-1.4112-.58413-.5293 0-1.0367.21004-1.411.58413l-6.102 6.09966c-.1249.1247-.2942.1948-.4706.1948s-.34559-.0701-.4704-.1948L3.45799 5.17424c-.18282-.1962-.40322-.35356-.64819-.46284-.24496-.10908-.50948-.16771-.77763-.17252-.26815-.00462-.5344.04457-.78305.14516-.24867.1004-.474661.2498-.664287.43952-.189649.18953-.339047.41548-.439474.6642-.1004269.24869-.14977518.51496-.14504894.78307.00472624.2682.06339314.53247.17253994.77765.109148.24497.266557.46531.462751.64814L6.73748 14.0986c.87369.8727 2.05823 1.3628 3.29302 1.3628 1.2348 0 2.4191-.4901 3.2929-1.3628l6.1019-6.10198c.3688-.37721.5751-.88401.5747-1.41155-.0004-.52772-.2077-1.03418-.5771-1.41083Z"
      />
    </svg>
  );
}
